var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"digido-form-builder digido-form-viewer"},[_c('form-builder',{attrs:{"form":_vm.value,"options":{}},on:{"change":function (schema) { return _vm.update(schema); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }